import capitalizeText from './capitalizeText'
import dig from './dig'
import documentName from './documentName'
import formatOrderValue from './formatOrderValue'
import insertArrayAt from './insertArrayAt'
import letterOnly from './letterOnly'
import pluck from './pluck'
import reduceRoutesToArray from './reduceRoutesToArray'
import upperText from './upperText'

const functions = {
  capitalizeText,
  dig,
  documentName,
  formatOrderValue,
  insertArrayAt,
  letterOnly,
  pluck,
  reduceRoutesToArray,
  upperText,
}

export default functions
